import React, { Component } from 'react';

class MainMenu extends Component {
    constructor(props) {
      super(props);
      this.state = {};

      this.nameInput = React.createRef();
      this.gameInput = React.createRef();
    }

    handleSubmit(e) {
        if(this.nameInput.current.value.indexOf('.') === -1){
          this.props.setName(this.nameInput.current.value);
        }
        if(this.gameInput.current.value.indexOf('.') === -1){
          this.props.setGame(this.gameInput.current.value);
        }

        e.preventDefault();
    }
  
    render() {
      return (
        <div className="MainMenu">
            <form onSubmit={e => this.handleSubmit(e)}>
                <h2>Your name</h2>
                <input type="text" name="name" id="name" defaultValue={this.props.name} placeholder="Gary King" ref={this.nameInput} />
                <h2>Mile ID</h2>
                <input type="text" name="game" id="game" defaultValue={this.props.game} disabled={this.props.lockGameId} ref={this.gameInput} />
                <div className="actions">
                  <input type="submit" value="Join The Mile" />
                </div>
            </form>
        </div>
      );
    }
}

export default MainMenu;